"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.symbol.description.js");
var _react = _interopRequireWildcard(require("react"));
var _drei = require("@react-three/drei");
var _reactRedux = require("react-redux");
var _fiber = require("@react-three/fiber");
var _selectors = require("../../redux/selectors");
var _constants = require("../../utils/constants");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const defaultPosition = {
  [_constants.CameraPerspective.ThreeD]: {
    polarAngle: Math.PI / 2.46,
    azimuthAngle: Math.PI / 1.52
  },
  [_constants.CameraPerspective.TwoD]: {
    polarAngle: Math.PI / 2,
    azimuthAngle: Math.PI / 2
  }
};
const defaultAngles = {
  [_constants.CameraPerspective.ThreeD]: {
    minPolarAngle: Math.PI / 5,
    maxPolarAngle: Math.PI / 2,
    minAzimuthAngle: Math.PI / 6,
    maxAzimuthAngle: Math.PI / 1.2
  },
  [_constants.CameraPerspective.TwoD]: {
    minPolarAngle: Math.PI / 5,
    maxPolarAngle: Math.PI / 5,
    minAzimuthAngle: Math.PI / 2,
    maxAzimuthAngle: Math.PI / 2
  }
};
const CameraControls = _ref => {
  var _angles$current, _angles$current2, _angles$current3, _angles$current4;
  let {
    cameraMoving = {}
  } = _ref;
  const controls = (0, _react.useRef)(null);
  const angles = (0, _react.useRef)(_objectSpread({}, defaultAngles[_constants.CameraPerspective.ThreeD]));
  const activeCameraPerspective = (0, _reactRedux.useSelector)(_selectors.getActiveCameraPerspective);
  const is2D = activeCameraPerspective === _constants.CameraPerspective.TwoD;
  const setAngle = (0, _react.useCallback)(function () {
    let cameraType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _constants.CameraPerspective.ThreeD;
    let type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    const defaultAngle = defaultAngles[cameraType];
    if (angles.current && Math.abs(defaultAngle[type] - angles.current[type]) > 0.000001) {
      angles.current[type] += (defaultAngle[type] - angles.current[type]) / 4;
      controls.current[type] = angles.current[type];
    }
  }, [is2D]);
  (0, _fiber.useFrame)(() => {
    if (is2D) {
      setAngle(_constants.CameraPerspective.TwoD, 'minPolarAngle');
      setAngle(_constants.CameraPerspective.TwoD, 'maxPolarAngle');
      setAngle(_constants.CameraPerspective.TwoD, 'minAzimuthAngle');
      setAngle(_constants.CameraPerspective.TwoD, 'maxAzimuthAngle');
    } else {
      setAngle(_constants.CameraPerspective.ThreeD, 'minPolarAngle');
      setAngle(_constants.CameraPerspective.ThreeD, 'maxPolarAngle');
      setAngle(_constants.CameraPerspective.ThreeD, 'minAzimuthAngle');
      setAngle(_constants.CameraPerspective.ThreeD, 'maxAzimuthAngle');
    }
  });
  (0, _react.useEffect)(() => {
    if (is2D) {
      controls.current.setAzimuthalAngle(defaultPosition[_constants.CameraPerspective.TwoD].azimuthAngle);
      controls.current.setPolarAngle(defaultPosition[_constants.CameraPerspective.TwoD].polarAngle);
    } else {
      controls.current.setAzimuthalAngle(defaultPosition[_constants.CameraPerspective.ThreeD].azimuthAngle);
      controls.current.setPolarAngle(defaultPosition[_constants.CameraPerspective.ThreeD].polarAngle);
    }
  }, [is2D]);
  (0, _react.useEffect)(() => {
    let timout = null;
    timout = setTimeout(() => {
      if (cameraMoving.current) {
        controls.current.setAzimuthalAngle(defaultPosition[_constants.CameraPerspective.ThreeD].azimuthAngle);
        controls.current.setPolarAngle(defaultPosition[_constants.CameraPerspective.ThreeD].polarAngle);
      }
    }, 1500);
    return () => clearTimeout(timout);
  }, []);
  return /*#__PURE__*/_react.default.createElement("group", null, /*#__PURE__*/_react.default.createElement(_drei.OrbitControls, {
    makeDefault: true,
    ref: controls,
    rotateSpeed: 0.25,
    minPolarAngle: (_angles$current = angles.current) === null || _angles$current === void 0 ? void 0 : _angles$current.minPolarAngle,
    maxPolarAngle: (_angles$current2 = angles.current) === null || _angles$current2 === void 0 ? void 0 : _angles$current2.maxPolarAngle,
    maxAzimuthAngle: (_angles$current3 = angles.current) === null || _angles$current3 === void 0 ? void 0 : _angles$current3.maxAzimuthAngle,
    minAzimuthAngle: (_angles$current4 = angles.current) === null || _angles$current4 === void 0 ? void 0 : _angles$current4.minAzimuthAngle,
    enableRotate: true,
    enableZoom: true,
    minZoom: 3,
    maxZoom: 20
  }));
};
var _default = exports.default = CameraControls;